import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import {getAuditPlanAccounts} from '../../util/Ares/auditPlanSummaryState';

export default function reducer(state = {}, action) {
	switch (action.type) {
		case types.GET_ACCOUNTS:
			if (action.response && action.response.data && !action.isManageAccounts) {
				const _risks = action.response.data.flatMap((account) => account.assertions || []).flatMap((assertion) => assertion.risks || []);
				const newState = action.mergeStrategy ? normalize(_risks, undefined, state, action.mergeStrategy) : normalize(_risks);
				return newState;
			}
			return state;
		// Audit plan summary bodies (356, 357) read risks from this slice, and their accounts arrive one
		// page at a time, so their responses always merge instead of replacing.
		case types.LIST_AUDIT_PLAN_ACCOUNTS:
		case types.GET_AUDIT_PLAN_ACCOUNT_BY_ID: {
			const accounts = getAuditPlanAccounts(action);
			if (!accounts.length) return state;

			const _risks = accounts.flatMap((account) => account.assertions || []).flatMap((assertion) => assertion.risks || []);
			return normalize(_risks, undefined, state, action.mergeStrategy || undefined);
		}
		default:
			return state;
	}
}
